import React from 'react';
import classNames from 'classnames';
import { getIconByName } from './shared_icons/PolarisIcons';
import actionButtonStyles from '../../../stylesheets/management_site/actionButton.module.scss';

const POLARIS = (window as any).RAILS_CONSTANTS?.['polaris'];

interface ActionButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  iconName?: string;
  text: string;
  className?: string;
  textClassName?: string;
  iconPosition?: 'left' | 'right';
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

const ActionButton = ({
  onClick,
  iconName,
  text,
  className,
  textClassName,
  iconPosition = 'left',
  buttonProps,
}: ActionButtonProps) => {
  const { className: buttonClassName, ...restButtonProps } = buttonProps || {};

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'mdc-button',
        'mdc-button--bordered',
        {
          [actionButtonStyles.actionButton]: POLARIS,
          [actionButtonStyles.textButton]: POLARIS && text,
          [actionButtonStyles.textOnlyButton]: POLARIS && text && !iconName,
          [actionButtonStyles.iconRight]: POLARIS && iconPosition === 'right',
        },
        className,
        buttonClassName
      )}
      data-test-class={
        text
          ? `action-button-${text.toLowerCase().replace(/\s+/g, '-')}`
          : `action-button-${iconName}`
      }
      {...restButtonProps}
    >
      {iconName && iconPosition === 'left' && getIconByName(iconName)}
      {text && <span className={textClassName}>{text}</span>}
      {iconName && iconPosition === 'right' && getIconByName(iconName)}
    </button>
  );
};

export default ActionButton;
